import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxDatePipe,
  OnyxIconButtonComponent,
  OnyxInformationHeadingComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import type { Note } from '../../../interfaces/common/note';
import { NavigationHelper } from '../../../helpers/navigation.helper';

@Component({
  selector: 'app-modal-note',
  imports: [
    TranslatePipe,
    OnyxDatePipe,
    OnyxIconButtonComponent,
    OnyxTooltipDirective,
    OnyxInformationHeadingComponent,
  ],
  templateUrl: './modal-note.component.html',
  styleUrl: './modal-note.component.scss',
})
export class ModalNoteComponent {
  private readonly router = inject(Router);

  public readonly heading = input('labels.officeNote');
  public readonly note = input.required<Note | null>();
  public readonly route = input<string>();
  public readonly close$ = input.required<Subject<void>>();

  protected edit(): void {
    const route = this.route();
    if (!route) return;

    this.router.navigateByUrl(route, NavigationHelper.withOrigin(this.router));
    this.close$().next();
  }
}
